import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Box,
  Typography,
  Tabs,
  Divider,
  Button
} from "@material-ui/core";
import EmployeePanel from "../../components/panel/employeePanel";
import CustomTab from "components/tab";
import { AddIcon } from "components/icon";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import OnlineEmployeePanel from "../../components/panel/onlineEmployeePanel";
import { getLang } from "app/feature/constants";
//import InfoEmployeePanel from "../../components/panel/infoEmployeePanel";

const style = (theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "7fr 3fr",
    gridTemplayeRows: "auto auto",
    columnGap: theme.spacing(2),
    gridTemplateAreas: "'topbar .''panel photo'",
    [theme.breakpoints.down("md")]: {
      gridTemplateAreas: "'topbar topbar''panel photo'",
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: "'topbar topbar''panel panel''photo photo'"
    },
  },
  indicator: {
    border: "0.5px solid",
    borderColor: theme.palette.primary.main
  },
  scroll: {
    width: "min-content"
  }
});

const useStyles = makeStyles(style);

function TabPanel({ children, value, index, ...other }) {
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

export default function MainPageComponent({
  hasEmployeeAddAccessRight,
  handleChange,
  activeIndex,
  tabLabels,
  lang,
  isWithinLimit,
}) {
  const classes = useStyles();
  const employeeRef = useRef();

  const openCreateEmployeeModal = () => {
    employeeRef.current.openCreateEmployeeModal();
  };

  function a11yProps(index, label = "label") {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tab-${index}`,
      label: <Typography variant="button" children={label} />,
    };
  }

  return (
    <Box className={classes.root}>
      <Box gridArea="topbar">
        <Box
          mb={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" alignItems="flex-end" fontWeight="bold">
            <Typography variant="h6" color="primary">
              {getLang(lang, "label.EMPLOYEE")}
            </Typography>
            <Box mx={0.5}>
              <ChevronRightRoundedIcon color="disabled" />
            </Box>
            <Box>
              <Typography variant="h6" color="primary">
                {tabLabels[activeIndex]}
              </Typography>
            </Box>
          </Box>

          {
            activeIndex === 0 && hasEmployeeAddAccessRight && isWithinLimit
              ?
              (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={
                    <AddIcon color="secondary" style={{ fontSize: "13px" }} />
                  }
                  disableElevation
                  onClick={openCreateEmployeeModal}
                >
                  {getLang(lang, "label.EMPLOYEE")}
                </Button>
              )
              : null
          }
        </Box>
        <Divider />
      </Box>

      <Box gridArea="panel" maxWidth="100%" overflow="hidden">
        <Box>
          <Box>
            <Tabs
              value={activeIndex}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              textColor="primary"
              variant="scrollable"
              indicatorColor="primary"
              classes={{
                indicator: classes.indicator,
                scrollButtons: classes.scroll,
              }}
            >
              {tabLabels.map((item, index) => {
                return <CustomTab key={index} {...a11yProps(index, item)} />;
              })}
            </Tabs>
          </Box>

          <Box>
            <TabPanel value={activeIndex} index={0}>
              <EmployeePanel ref={employeeRef} />
            </TabPanel>
          </Box>
        </Box>
      </Box>

      <Box gridArea="photo" mt={{ xs: 3, sm: 3, md: 6 }}>
        <TabPanel value={activeIndex} index={0}>
          <OnlineEmployeePanel />
          {/* <InfoEmployeePanel /> */}
        </TabPanel>
      </Box>
    </Box>
  );
}
